export default __webpack_public_path__ + "static/292-9cfc57a97322c9768cea10c6dd00d7b3.gif";